module.exports = __webpack_public_path__ + "img/multiplier.9033f6d4.png";